{
  "modules": [
    {
      "number": "1",
      "title": "Opening · Why This Course Exists",
      "lessons": [
        {
          "number": "1.1",
          "id": "cl-open-cover",
          "slug": "open-cover",
          "title": "Cover",
          "duration": "3:40"
        },
        {
          "number": "1.2",
          "id": "cl-open-what-this-course-is",
          "slug": "open-what-this-course-is",
          "title": "What this course is: one real build, start to finish",
          "duration": "3:15"
        },
        {
          "number": "1.3",
          "id": "cl-open-working-app-proves-nothing",
          "slug": "open-working-app-proves-nothing",
          "title": "A working app from an agent doesn't prove AI engineering skill",
          "duration": "2:38"
        },
        {
          "number": "1.4",
          "id": "cl-open-what-reviewers-look-for",
          "slug": "open-what-reviewers-look-for",
          "title": "What a recruiter or engineering manager actually looks for",
          "duration": "4:15"
        },
        {
          "number": "1.5",
          "id": "cl-open-model-works-gates-verify",
          "slug": "open-model-works-gates-verify",
          "title": "The model works, the gates verify, the outcome is yours",
          "duration": "2:21"
        },
        {
          "number": "1.6",
          "id": "cl-open-three-columns",
          "slug": "open-three-columns",
          "title": "How the work splits into three columns",
          "duration": "3:20"
        },
        {
          "number": "1.7",
          "id": "cl-open-who-this-is-for",
          "slug": "open-who-this-is-for",
          "title": "Who this is for",
          "duration": "2:39"
        },
        {
          "number": "1.8",
          "id": "cl-open-what-youll-have-seen",
          "slug": "open-what-youll-have-seen",
          "title": "What you'll have seen by the end",
          "duration": "5:09"
        },
        {
          "number": "1.9",
          "id": "cl-open-same-drink-new-bottle",
          "slug": "open-same-drink-new-bottle",
          "title": "Same Old Drink, New Bottle",
          "duration": "3:37"
        }
      ],
      "isPublished": true
    },
    {
      "number": "2",
      "title": "Phase 02 · Discovery",
      "lessons": [
        {
          "number": "2.1",
          "id": "cl-disc-jsonl-never-opened",
          "slug": "disc-jsonl-never-opened",
          "title": "Inspecting Claude Code’s local session traces",
          "duration": "0:00"
        },
        {
          "number": "2.2",
          "id": "cl-disc-meet-claude-lens",
          "slug": "disc-meet-claude-lens",
          "title": "Meet the build: Claude Lens",
          "duration": "0:00"
        },
        {
          "number": "2.3",
          "id": "cl-disc-what-does-a-turn-cost",
          "slug": "disc-what-does-a-turn-cost",
          "title": "The question: what does a turn cost",
          "duration": "0:00"
        },
        {
          "number": "2.4",
          "id": "cl-disc-where-cost-appears",
          "slug": "disc-where-cost-appears",
          "title": "Where Claude Code exposes cost",
          "duration": "0:00"
        },
        {
          "number": "2.5",
          "id": "cl-disc-nobody-hands-you-per-turn-cost",
          "slug": "disc-nobody-hands-you-per-turn-cost",
          "title": "The verdict: nobody hands you per-turn cost",
          "duration": "0:00"
        },
        {
          "number": "2.6",
          "id": "cl-disc-trigger-pointer-math",
          "slug": "disc-trigger-pointer-math",
          "title": "The theory: trigger, pointer, math",
          "duration": "0:00"
        },
        {
          "number": "2.7",
          "id": "cl-disc-the-reveal-hooks",
          "slug": "disc-the-reveal-hooks",
          "title": "The reveal: hooks",
          "duration": "0:00"
        },
        {
          "number": "2.8",
          "id": "cl-disc-vibe-coding-on-purpose",
          "slug": "disc-vibe-coding-on-purpose",
          "title": "Vibe coding on purpose",
          "duration": "0:00"
        },
        {
          "number": "2.9",
          "id": "cl-disc-cost-poc",
          "slug": "disc-cost-poc",
          "title": "The cost spike, end to end",
          "duration": "0:00"
        },
        {
          "number": "2.10",
          "id": "cl-disc-log-filling-up",
          "slug": "disc-log-filling-up",
          "title": "The logs filling up",
          "duration": "0:00"
        },
        {
          "number": "2.11",
          "id": "cl-disc-hook-catalog",
          "slug": "disc-hook-catalog",
          "title": "Beyond Stop: the hook catalog",
          "duration": "0:00"
        },
        {
          "number": "2.12",
          "id": "cl-disc-vibe-coded-dashboard-proof",
          "slug": "disc-vibe-coded-dashboard-proof",
          "title": "Vibe-coded dashboard proof",
          "duration": "0:00"
        },
        {
          "number": "2.13",
          "id": "cl-disc-keep-or-kill",
          "slug": "disc-keep-or-kill",
          "title": "Keep or kill",
          "duration": "0:00"
        },
        {
          "number": "2.14",
          "id": "cl-disc-poc-proved-data-not-product",
          "slug": "disc-poc-proved-data-not-product",
          "title": "The spike proved feasibility, not the product",
          "duration": "0:00"
        }
      ],
      "isPublished": false
    },
    {
      "number": "3",
      "title": "Phase 03 · Concept",
      "lessons": [
        {
          "number": "3.1",
          "id": "cl-concept-html-before-real-code",
          "slug": "concept-html-before-real-code",
          "title": "The idea stood up in HTML before any real code",
          "duration": "0:00"
        },
        {
          "number": "3.2",
          "id": "cl-concept-conversation-about-whats-built",
          "slug": "concept-conversation-about-whats-built",
          "title": "First job: a conversation about what's being built",
          "duration": "0:00"
        },
        {
          "number": "3.3",
          "id": "cl-concept-screens-from-design-tool",
          "slug": "concept-screens-from-design-tool",
          "title": "Screens generated with a design tool — raw HTML + CSS",
          "duration": "0:00"
        },
        {
          "number": "3.4",
          "id": "cl-concept-html-sketchpad-png-reference",
          "slug": "concept-html-sketchpad-png-reference",
          "title": "HTML is the sketchpad. PNG is the fixed reference.",
          "duration": "0:00"
        },
        {
          "number": "3.5",
          "id": "cl-concept-stack-still-open",
          "slug": "concept-stack-still-open",
          "title": "The stack was still open at this point",
          "duration": "0:00"
        },
        {
          "number": "3.6",
          "id": "cl-concept-design-export-freeze",
          "slug": "concept-design-export-freeze",
          "title": "Design → export → freeze",
          "duration": "0:00"
        },
        {
          "number": "3.7",
          "id": "cl-concept-what-came-out",
          "slug": "concept-what-came-out",
          "title": "What came out of this phase",
          "duration": "0:00"
        },
        {
          "number": "3.8",
          "id": "cl-concept-tool-access-note",
          "slug": "concept-tool-access-note",
          "title": "A practical note on tool access",
          "duration": "0:00"
        },
        {
          "number": "3.9",
          "id": "cl-concept-what-it-takes-to-start",
          "slug": "concept-what-it-takes-to-start",
          "title": "What it takes to start here",
          "duration": "0:00"
        }
      ],
      "isPublished": false
    },
    {
      "number": "4",
      "title": "Interlude · The Map I Drew Before Building",
      "lessons": [
        {
          "number": "4.1",
          "id": "cl-map-same-drink-new-bottle",
          "slug": "map-same-drink-new-bottle",
          "title": "Same Old Drink, New Bottle",
          "duration": "0:00"
        },
        {
          "number": "4.2",
          "id": "cl-map-skeleton-five-phases",
          "slug": "map-skeleton-five-phases",
          "title": "The skeleton: five phases",
          "duration": "0:00"
        },
        {
          "number": "4.3",
          "id": "cl-map-five-hats-one-framework",
          "slug": "map-five-hats-one-framework",
          "title": "Five hats, one framework",
          "duration": "0:00"
        },
        {
          "number": "4.4",
          "id": "cl-map-hold-onto-this-diagram",
          "slug": "map-hold-onto-this-diagram",
          "title": "Hold onto this diagram — building it changed the shape",
          "duration": "0:00"
        }
      ],
      "isPublished": false
    },
    {
      "number": "5",
      "title": "Phase 05 · Foundation",
      "lessons": [
        {
          "number": "5.1",
          "id": "cl-found-map-assumed-a-foundation",
          "slug": "found-map-assumed-a-foundation",
          "title": "The map started at requirements — it assumed a foundation already existed",
          "duration": "0:00"
        },
        {
          "number": "5.2",
          "id": "cl-found-when-does-stack-get-picked",
          "slug": "found-when-does-stack-get-picked",
          "title": "When does the stack get picked? It depends.",
          "duration": "0:00"
        },
        {
          "number": "5.3",
          "id": "cl-found-after-poc-after-design",
          "slug": "found-after-poc-after-design",
          "title": "In this build it came after the POC and after the design — that's one route, not the route",
          "duration": "0:00"
        },
        {
          "number": "5.4",
          "id": "cl-found-timing-varies-interrogation-doesnt",
          "slug": "found-timing-varies-interrogation-doesnt",
          "title": "The timing varies. The interrogation shouldn't.",
          "duration": "0:00"
        },
        {
          "number": "5.5",
          "id": "cl-found-two-kinds-of-feature",
          "slug": "found-two-kinds-of-feature",
          "title": "Two kinds of feature, and the argument that decides which is which",
          "duration": "0:00"
        },
        {
          "number": "5.6",
          "id": "cl-found-foundational-or-product",
          "slug": "found-foundational-or-product",
          "title": "Foundational or product — every piece of work gets split",
          "duration": "0:00"
        },
        {
          "number": "5.7",
          "id": "cl-found-product-stands-on-foundation",
          "slug": "found-product-stands-on-foundation",
          "title": "Every product feature stands on shared foundation",
          "duration": "0:00"
        },
        {
          "number": "5.8",
          "id": "cl-found-does-local-tool-need-postgres",
          "slug": "found-does-local-tool-need-postgres",
          "title": "Does a local, single-user tool really need Postgres?",
          "duration": "0:00"
        },
        {
          "number": "5.9",
          "id": "cl-found-arguing-with-an-agreeable-agent",
          "slug": "found-arguing-with-an-agreeable-agent",
          "title": "How to argue with an agent that wants to agree with you",
          "duration": "0:00"
        },
        {
          "number": "5.10",
          "id": "cl-found-model-builds-case-you-pushed",
          "slug": "found-model-builds-case-you-pushed",
          "title": "Push it and the model builds the case for whichever side you pushed",
          "duration": "0:00"
        },
        {
          "number": "5.11",
          "id": "cl-found-five-questions-that-produce-material",
          "slug": "found-five-questions-that-produce-material",
          "title": "Five questions that produce material instead of agreement",
          "duration": "0:00"
        },
        {
          "number": "5.12",
          "id": "cl-found-useful-answer-vs-agreement",
          "slug": "found-useful-answer-vs-agreement",
          "title": "How to tell whether an answer was useful",
          "duration": "0:00"
        },
        {
          "number": "5.13",
          "id": "cl-found-agreement-noise-specificity-signal",
          "slug": "found-agreement-noise-specificity-signal",
          "title": "Treat agreement as noise. Treat specificity as signal.",
          "duration": "0:00"
        },
        {
          "number": "5.14",
          "id": "cl-found-familiar-tool-vs-right-tool",
          "slug": "found-familiar-tool-vs-right-tool",
          "title": "The familiar tool and the right tool are not the same tool",
          "duration": "0:00"
        },
        {
          "number": "5.15",
          "id": "cl-found-dont-bury-the-decision",
          "slug": "found-dont-bury-the-decision",
          "title": "Don't leave the decision buried in a chat log",
          "duration": "0:00"
        },
        {
          "number": "5.16",
          "id": "cl-found-decision-in-five-parts",
          "slug": "found-decision-in-five-parts",
          "title": "Every significant decision written in five parts",
          "duration": "0:00"
        },
        {
          "number": "5.17",
          "id": "cl-found-the-tripwire",
          "slug": "found-the-tripwire",
          "title": "The tripwire — the part that keeps a decision alive",
          "duration": "0:00"
        },
        {
          "number": "5.18",
          "id": "cl-found-adr-worked-example",
          "slug": "found-adr-worked-example",
          "title": "What that record looks like, filled in",
          "duration": "0:00"
        },
        {
          "number": "5.19",
          "id": "cl-found-runnable-foundation-planned-first",
          "slug": "found-runnable-foundation-planned-first",
          "title": "The runnable foundation got planned before any feature",
          "duration": "0:00"
        },
        {
          "number": "5.20",
          "id": "cl-found-every-task-ends-booting",
          "slug": "found-every-task-ends-booting",
          "title": "Every foundation task ends with a repository that boots",
          "duration": "0:00"
        },
        {
          "number": "5.21",
          "id": "cl-found-starting-from-schema",
          "slug": "found-starting-from-schema",
          "title": "What starting from schema gets you",
          "duration": "0:00"
        },
        {
          "number": "5.22",
          "id": "cl-found-every-commit-boots",
          "slug": "found-every-commit-boots",
          "title": "Every commit boots — so every commit can be verified",
          "duration": "0:00"
        },
        {
          "number": "5.23",
          "id": "cl-found-what-walking-skeleton-is",
          "slug": "found-what-walking-skeleton-is",
          "title": "What a walking skeleton actually is",
          "duration": "0:00"
        },
        {
          "number": "5.24",
          "id": "cl-found-test-strategy-decided-here",
          "slug": "found-test-strategy-decided-here",
          "title": "Test strategy got decided here too",
          "duration": "0:00"
        },
        {
          "number": "5.25",
          "id": "cl-found-cheapest-test-that-catches",
          "slug": "found-cheapest-test-that-catches",
          "title": "The cheapest test that catches the failure you actually fear",
          "duration": "0:00"
        },
        {
          "number": "5.26",
          "id": "cl-found-real-engine-disposable-container",
          "slug": "found-real-engine-disposable-container",
          "title": "Not an in-memory substitute — the real engine, in a disposable container",
          "duration": "0:00"
        },
        {
          "number": "5.27",
          "id": "cl-found-screenshot-diffing-where-appearance-is-contract",
          "slug": "found-screenshot-diffing-where-appearance-is-contract",
          "title": "Screenshot diffing only where appearance is the contract",
          "duration": "0:00"
        },
        {
          "number": "5.28",
          "id": "cl-found-tests-as-oracles",
          "slug": "found-tests-as-oracles",
          "title": "See tests as oracles, not checks",
          "duration": "0:00"
        },
        {
          "number": "5.29",
          "id": "cl-found-four-oracles",
          "slug": "found-four-oracles",
          "title": "Four oracles, four kinds of mistake",
          "duration": "0:00"
        },
        {
          "number": "5.30",
          "id": "cl-found-verified-plan-zero-features",
          "slug": "found-verified-plan-zero-features",
          "title": "What this phase produced: not implementation, but a verified plan for a runnable app with zero features",
          "duration": "0:00"
        }
      ],
      "isPublished": false
    },
    {
      "number": "6",
      "title": "Phase 06 · Ticketing",
      "lessons": [
        {
          "number": "6.1",
          "id": "cl-ticket-screens-became-tickets",
          "slug": "ticket-screens-became-tickets",
          "title": "Screens became tickets — still nothing implemented",
          "duration": "0:00"
        },
        {
          "number": "6.2",
          "id": "cl-ticket-one-page-is-not-one-task",
          "slug": "ticket-one-page-is-not-one-task",
          "title": "One page is not one task",
          "duration": "0:00"
        },
        {
          "number": "6.3",
          "id": "cl-ticket-choreographed-not-a-list",
          "slug": "ticket-choreographed-not-a-list",
          "title": "Not a feature list. Choreographed.",
          "duration": "0:00"
        },
        {
          "number": "6.4",
          "id": "cl-ticket-versioned-files-not-in-your-head",
          "slug": "ticket-versioned-files-not-in-your-head",
          "title": "In the repository as versioned files, not in your head",
          "duration": "0:00"
        },
        {
          "number": "6.5",
          "id": "cl-ticket-what-a-good-ticket-makes-clear",
          "slug": "ticket-what-a-good-ticket-makes-clear",
          "title": "What a good ticket makes clear",
          "duration": "0:00"
        },
        {
          "number": "6.6",
          "id": "cl-ticket-what-a-ticket-looked-like",
          "slug": "ticket-what-a-ticket-looked-like",
          "title": "What a ticket actually looked like",
          "duration": "0:00"
        },
        {
          "number": "6.7",
          "id": "cl-ticket-fresh-session-test",
          "slug": "ticket-fresh-session-test",
          "title": "Could a fresh session with no conversation history produce the right output from this ticket alone?",
          "duration": "0:00"
        },
        {
          "number": "6.8",
          "id": "cl-ticket-procedure-not-one-prompt",
          "slug": "ticket-procedure-not-one-prompt",
          "title": "The skill isn't one clever prompt — it's a procedure that repeats",
          "duration": "0:00"
        },
        {
          "number": "6.9",
          "id": "cl-ticket-freeze-read-then-load",
          "slug": "ticket-freeze-read-then-load",
          "title": "Freeze it, read all of it, then load it",
          "duration": "0:00"
        },
        {
          "number": "6.10",
          "id": "cl-ticket-fine-apart-conflicting-together",
          "slug": "ticket-fine-apart-conflicting-together",
          "title": "Fine apart, conflicting together",
          "duration": "0:00"
        },
        {
          "number": "6.11",
          "id": "cl-ticket-versioned-task-set-is-the-spec",
          "slug": "ticket-versioned-task-set-is-the-spec",
          "title": "After review, this versioned task set is the spec",
          "duration": "0:00"
        },
        {
          "number": "6.12",
          "id": "cl-ticket-one-ticket-one-session",
          "slug": "ticket-one-ticket-one-session",
          "title": "Not the whole spec in one session",
          "duration": "0:00"
        },
        {
          "number": "6.13",
          "id": "cl-ticket-script-must-be-idempotent",
          "slug": "ticket-script-must-be-idempotent",
          "title": "The script has to be idempotent",
          "duration": "0:00"
        },
        {
          "number": "6.14",
          "id": "cl-ticket-tracker-is-the-memory",
          "slug": "ticket-tracker-is-the-memory",
          "title": "The issue tracker is the memory the agent doesn't have",
          "duration": "0:00"
        }
      ],
      "isPublished": false
    },
    {
      "number": "7",
      "title": "Phase 07 · Implementation",
      "lessons": [
        {
          "number": "7.1",
          "id": "cl-impl-now-the-loop",
          "slug": "impl-now-the-loop",
          "title": "Now — and only now — the implementation loop",
          "duration": "0:00"
        },
        {
          "number": "7.2",
          "id": "cl-impl-five-phases-were-the-engine",
          "slug": "impl-five-phases-were-the-engine",
          "title": "The five phases weren't the lifecycle — they became this phase's engine",
          "duration": "0:00"
        },
        {
          "number": "7.3",
          "id": "cl-impl-corrected-loop",
          "slug": "impl-corrected-loop",
          "title": "The derived loop: the five skills plus ship, once per issue",
          "duration": "0:00"
        },
        {
          "number": "7.4",
          "id": "cl-impl-one-pass-per-issue",
          "slug": "impl-one-pass-per-issue",
          "title": "The build did not start every issue at step one",
          "duration": "0:00"
        },
        {
          "number": "7.5",
          "id": "cl-impl-inside-one-pass",
          "slug": "impl-inside-one-pass",
          "title": "Inside one pass: branch → commit → PR → review → fix → merge",
          "duration": "0:00"
        },
        {
          "number": "7.6",
          "id": "cl-impl-plan-first-then-edit",
          "slug": "impl-plan-first-then-edit",
          "title": "Plan first, then edit",
          "duration": "0:00"
        },
        {
          "number": "7.7",
          "id": "cl-impl-three-again-per-issue",
          "slug": "impl-three-again-per-issue",
          "title": "Three planning roles, two actual entry points",
          "duration": "0:00"
        },
        {
          "number": "7.8",
          "id": "cl-impl-foundation-vs-plan-architecture",
          "slug": "impl-foundation-vs-plan-architecture",
          "title": "Product-level Foundation vs per-issue `plan-architecture`",
          "duration": "0:00"
        },
        {
          "number": "7.9",
          "id": "cl-impl-ticketing-vs-generate-tasks",
          "slug": "impl-ticketing-vs-generate-tasks",
          "title": "Product-level Ticketing vs per-issue `generate-tasks`",
          "duration": "0:00"
        }
      ],
      "isPublished": false
    },
    {
      "number": "8",
      "title": "Loop Step 1 · Plan Requirements",
      "lessons": [
        {
          "number": "8.1",
          "id": "cl-loop-req-craft",
          "slug": "loop-req-craft",
          "title": "Requirements craft",
          "duration": "0:00"
        },
        {
          "number": "8.2",
          "id": "cl-loop-req-why",
          "slug": "loop-req-why",
          "title": "Why plan-requirements",
          "duration": "0:00"
        },
        {
          "number": "8.3",
          "id": "cl-loop-req-how",
          "slug": "loop-req-how",
          "title": "plan-requirements: how",
          "duration": "0:00"
        },
        {
          "number": "8.4",
          "id": "cl-loop-req-demo",
          "slug": "loop-req-demo",
          "title": "Demo: plan-requirements",
          "duration": "0:00"
        }
      ],
      "isPublished": false
    },
    {
      "number": "9",
      "title": "Loop Step 2 · Plan Architecture",
      "lessons": [
        {
          "number": "9.1",
          "id": "cl-loop-arch-craft",
          "slug": "loop-arch-craft",
          "title": "Architecture craft",
          "duration": "0:00"
        },
        {
          "number": "9.2",
          "id": "cl-loop-arch-why",
          "slug": "loop-arch-why",
          "title": "Why plan-architecture",
          "duration": "0:00"
        },
        {
          "number": "9.3",
          "id": "cl-loop-arch-how",
          "slug": "loop-arch-how",
          "title": "plan-architecture: how",
          "duration": "0:00"
        },
        {
          "number": "9.4",
          "id": "cl-loop-arch-demo",
          "slug": "loop-arch-demo",
          "title": "Demo: plan-architecture",
          "duration": "0:00"
        }
      ],
      "isPublished": false
    },
    {
      "number": "10",
      "title": "Loop Step 3 · Generate Tasks",
      "lessons": [
        {
          "number": "10.1",
          "id": "cl-loop-tasks-craft",
          "slug": "loop-tasks-craft",
          "title": "Tasks craft",
          "duration": "0:00"
        },
        {
          "number": "10.2",
          "id": "cl-loop-tasks-why",
          "slug": "loop-tasks-why",
          "title": "Why generate-tasks",
          "duration": "0:00"
        },
        {
          "number": "10.3",
          "id": "cl-loop-tasks-how",
          "slug": "loop-tasks-how",
          "title": "generate-tasks: how",
          "duration": "0:00"
        },
        {
          "number": "10.4",
          "id": "cl-loop-tasks-demo",
          "slug": "loop-tasks-demo",
          "title": "Demo: generate-tasks",
          "duration": "0:00"
        }
      ],
      "isPublished": false
    },
    {
      "number": "11",
      "title": "Loop Step 4 · Implement",
      "lessons": [
        {
          "number": "11.1",
          "id": "cl-loop-implement-craft",
          "slug": "loop-implement-craft",
          "title": "Implement craft",
          "duration": "0:00"
        },
        {
          "number": "11.2",
          "id": "cl-loop-implement-why",
          "slug": "loop-implement-why",
          "title": "Why the implement skill",
          "duration": "0:00"
        },
        {
          "number": "11.3",
          "id": "cl-loop-implement-how",
          "slug": "loop-implement-how",
          "title": "implement: how",
          "duration": "0:00"
        },
        {
          "number": "11.4",
          "id": "cl-loop-implement-demo",
          "slug": "loop-implement-demo",
          "title": "Demo: implement",
          "duration": "0:00"
        }
      ],
      "isPublished": false
    },
    {
      "number": "12",
      "title": "Loop Step 5 · Review",
      "lessons": [
        {
          "number": "12.1",
          "id": "cl-loop-review-craft",
          "slug": "loop-review-craft",
          "title": "Review craft",
          "duration": "0:00"
        },
        {
          "number": "12.2",
          "id": "cl-loop-review-implements-is-a-claim",
          "slug": "loop-review-implements-is-a-claim",
          "title": "\"implements #34\" is a claim, not evidence",
          "duration": "0:00"
        },
        {
          "number": "12.3",
          "id": "cl-loop-review-why",
          "slug": "loop-review-why",
          "title": "Why the review skill",
          "duration": "0:00"
        },
        {
          "number": "12.4",
          "id": "cl-loop-review-how",
          "slug": "loop-review-how",
          "title": "review: how",
          "duration": "0:00"
        },
        {
          "number": "12.5",
          "id": "cl-loop-review-demo",
          "slug": "loop-review-demo",
          "title": "Demo: review",
          "duration": "0:00"
        }
      ],
      "isPublished": false
    },
    {
      "number": "13",
      "title": "Loop Step 6 · Ship",
      "lessons": [
        {
          "number": "13.1",
          "id": "cl-loop-ship-hypothesis-not-finish-line",
          "slug": "loop-ship-hypothesis-not-finish-line",
          "title": "Shipping is a hypothesis, not a finish line",
          "duration": "0:00"
        },
        {
          "number": "13.2",
          "id": "cl-loop-ship-ci-vs-production",
          "slug": "loop-ship-ci-vs-production",
          "title": "What CI says, and what post-release signals say",
          "duration": "0:00"
        },
        {
          "number": "13.3",
          "id": "cl-loop-ship-four-questions-before-deploy",
          "slug": "loop-ship-four-questions-before-deploy",
          "title": "Four questions answered before deploy",
          "duration": "0:00"
        },
        {
          "number": "13.4",
          "id": "cl-loop-ship-instrumentation-is-the-feature",
          "slug": "loop-ship-instrumentation-is-the-feature",
          "title": "Instrumentation is part of the feature, not post-release cleanup",
          "duration": "0:00"
        }
      ],
      "isPublished": false
    },
    {
      "number": "14",
      "title": "Loop · Running More Than One Pass",
      "lessons": [
        {
          "number": "14.1",
          "id": "cl-loop-parallel-git-worktree",
          "slug": "loop-parallel-git-worktree",
          "title": "Git worktree — one repository, separate working directories",
          "duration": "0:00"
        },
        {
          "number": "14.2",
          "id": "cl-loop-parallel-limit-is-review",
          "slug": "loop-parallel-limit-is-review",
          "title": "The limit on parallelism isn't set by the tool",
          "duration": "0:00"
        },
        {
          "number": "14.3",
          "id": "cl-loop-parallel-quick-fix-breaks-trail",
          "slug": "loop-parallel-quick-fix-breaks-trail",
          "title": "A quick fix straight on main breaks the paper trail",
          "duration": "0:00"
        }
      ],
      "isPublished": false
    },
    {
      "number": "15",
      "title": "Loop · Closing the Loop",
      "lessons": [
        {
          "number": "15.1",
          "id": "cl-loop-close-spec-build-ship-evidence",
          "slug": "loop-close-spec-build-ship-evidence",
          "title": "Spec → build → ship → evidence → spec again",
          "duration": "0:00"
        },
        {
          "number": "15.2",
          "id": "cl-loop-close-evidence-changes-spec",
          "slug": "loop-close-evidence-changes-spec",
          "title": "When the evidence says the spec was wrong, the spec changes",
          "duration": "0:00"
        }
      ],
      "isPublished": false
    },
    {
      "number": "16",
      "title": "Off the Timeline · The Operating Environment",
      "lessons": [
        {
          "number": "16.1",
          "id": "cl-env-operating-environment",
          "slug": "env-operating-environment",
          "title": "The operating environment",
          "duration": "0:00"
        },
        {
          "number": "16.2",
          "id": "cl-env-not-a-phase",
          "slug": "env-not-a-phase",
          "title": "Not a phase — the conditions every phase runs under",
          "duration": "0:00"
        }
      ],
      "isPublished": false
    },
    {
      "number": "17",
      "title": "Environment · Guardrails",
      "lessons": [
        {
          "number": "17.1",
          "id": "cl-env-guard-guardrails",
          "slug": "env-guard-guardrails",
          "title": "Guardrails",
          "duration": "0:00"
        },
        {
          "number": "17.2",
          "id": "cl-env-guard-credential-near-miss",
          "slug": "env-guard-credential-near-miss",
          "title": "Credential near-miss",
          "duration": "0:00"
        },
        {
          "number": "17.3",
          "id": "cl-env-guard-hooks-intro",
          "slug": "env-guard-hooks-intro",
          "title": "Hooks intro",
          "duration": "0:00"
        },
        {
          "number": "17.4",
          "id": "cl-env-guard-pretooluse-credential",
          "slug": "env-guard-pretooluse-credential",
          "title": "PreToolUse credential guard",
          "duration": "0:00"
        },
        {
          "number": "17.5",
          "id": "cl-env-guard-posttooluse-format",
          "slug": "env-guard-posttooluse-format",
          "title": "PostToolUse format",
          "duration": "0:00"
        },
        {
          "number": "17.6",
          "id": "cl-env-guard-demo-blocking",
          "slug": "env-guard-demo-blocking",
          "title": "Demo: hooks blocking",
          "duration": "0:00"
        },
        {
          "number": "17.7",
          "id": "cl-env-guard-what-agent-can-touch",
          "slug": "env-guard-what-agent-can-touch",
          "title": "What the agent is allowed to touch",
          "duration": "0:00"
        },
        {
          "number": "17.8",
          "id": "cl-env-guard-allowed-approval-never",
          "slug": "env-guard-allowed-approval-never",
          "title": "Allowed · needs your approval · never",
          "duration": "0:00"
        },
        {
          "number": "17.9",
          "id": "cl-env-guard-five-rules",
          "slug": "env-guard-five-rules",
          "title": "Five practical rules",
          "duration": "0:00"
        },
        {
          "number": "17.10",
          "id": "cl-env-guard-sandboxing",
          "slug": "env-guard-sandboxing",
          "title": "Sandboxing",
          "duration": "0:00"
        },
        {
          "number": "17.11",
          "id": "cl-env-guard-reflection",
          "slug": "env-guard-reflection",
          "title": "Guardrails reflection",
          "duration": "0:00"
        }
      ],
      "isPublished": false
    },
    {
      "number": "18",
      "title": "Environment · UI Automation",
      "lessons": [
        {
          "number": "18.1",
          "id": "cl-env-ui-automation",
          "slug": "env-ui-automation",
          "title": "UI automation",
          "duration": "0:00"
        },
        {
          "number": "18.2",
          "id": "cl-env-ui-manual-verification",
          "slug": "env-ui-manual-verification",
          "title": "Manual UI verification",
          "duration": "0:00"
        },
        {
          "number": "18.3",
          "id": "cl-env-ui-mcp-eyes-and-arms",
          "slug": "env-ui-mcp-eyes-and-arms",
          "title": "MCP: eyes and arms",
          "duration": "0:00"
        },
        {
          "number": "18.4",
          "id": "cl-env-ui-playwright-setup",
          "slug": "env-ui-playwright-setup",
          "title": "Playwright MCP setup",
          "duration": "0:00"
        },
        {
          "number": "18.5",
          "id": "cl-env-ui-demo-playwright",
          "slug": "env-ui-demo-playwright",
          "title": "Demo: Playwright",
          "duration": "0:00"
        },
        {
          "number": "18.6",
          "id": "cl-env-ui-more-mcp-servers",
          "slug": "env-ui-more-mcp-servers",
          "title": "More MCP servers",
          "duration": "0:00"
        },
        {
          "number": "18.7",
          "id": "cl-env-ui-reflection",
          "slug": "env-ui-reflection",
          "title": "UI automation reflection",
          "duration": "0:00"
        },
        {
          "number": "18.8",
          "id": "cl-env-ui-frontend-iterate-loop",
          "slug": "env-ui-frontend-iterate-loop",
          "title": "Frontend iterate loop",
          "duration": "0:00"
        }
      ],
      "isPublished": false
    },
    {
      "number": "19",
      "title": "Environment · Persistent Context",
      "lessons": [
        {
          "number": "19.1",
          "id": "cl-env-memory-persistent-context",
          "slug": "env-memory-persistent-context",
          "title": "Persistent context",
          "duration": "0:00"
        },
        {
          "number": "19.2",
          "id": "cl-env-memory-goldfish-problem",
          "slug": "env-memory-goldfish-problem",
          "title": "The goldfish problem",
          "duration": "0:00"
        },
        {
          "number": "19.3",
          "id": "cl-env-memory-why-agents-forget",
          "slug": "env-memory-why-agents-forget",
          "title": "Why agents forget",
          "duration": "0:00"
        },
        {
          "number": "19.4",
          "id": "cl-env-memory-four-systems",
          "slug": "env-memory-four-systems",
          "title": "Four memory systems",
          "duration": "0:00"
        },
        {
          "number": "19.5",
          "id": "cl-env-memory-claude-md-foundation",
          "slug": "env-memory-claude-md-foundation",
          "title": "CLAUDE.md foundation",
          "duration": "0:00"
        },
        {
          "number": "19.6",
          "id": "cl-env-memory-auto-memory",
          "slug": "env-memory-auto-memory",
          "title": "Auto memory",
          "duration": "0:00"
        },
        {
          "number": "19.7",
          "id": "cl-env-memory-rules-conditional",
          "slug": "env-memory-rules-conditional",
          "title": "Rules, conditional",
          "duration": "0:00"
        },
        {
          "number": "19.8",
          "id": "cl-env-memory-commands",
          "slug": "env-memory-commands",
          "title": "Memory commands",
          "duration": "0:00"
        },
        {
          "number": "19.9",
          "id": "cl-env-memory-lost-in-the-middle",
          "slug": "env-memory-lost-in-the-middle",
          "title": "Lost in the middle",
          "duration": "0:00"
        },
        {
          "number": "19.10",
          "id": "cl-env-memory-playbook",
          "slug": "env-memory-playbook",
          "title": "Memory playbook",
          "duration": "0:00"
        },
        {
          "number": "19.11",
          "id": "cl-env-memory-differentiator",
          "slug": "env-memory-differentiator",
          "title": "Memory differentiator",
          "duration": "0:00"
        },
        {
          "number": "19.12",
          "id": "cl-env-memory-reflection",
          "slug": "env-memory-reflection",
          "title": "Persistent context reflection",
          "duration": "0:00"
        }
      ],
      "isPublished": false
    },
    {
      "number": "20",
      "title": "Environment · Configuration and Trust",
      "lessons": [
        {
          "number": "20.1",
          "id": "cl-env-config-configuration-and-trust",
          "slug": "env-config-configuration-and-trust",
          "title": "Configuration and trust",
          "duration": "0:00"
        },
        {
          "number": "20.2",
          "id": "cl-env-config-collision",
          "slug": "env-config-collision",
          "title": "Configuration collision",
          "duration": "0:00"
        },
        {
          "number": "20.3",
          "id": "cl-env-config-five-levels",
          "slug": "env-config-five-levels",
          "title": "5-level settings",
          "duration": "0:00"
        },
        {
          "number": "20.4",
          "id": "cl-env-config-permission-modes",
          "slug": "env-config-permission-modes",
          "title": "Permission modes",
          "duration": "0:00"
        },
        {
          "number": "20.5",
          "id": "cl-env-config-permission-rules-syntax",
          "slug": "env-config-permission-rules-syntax",
          "title": "Permission rules syntax",
          "duration": "0:00"
        },
        {
          "number": "20.6",
          "id": "cl-env-config-degrading-session",
          "slug": "env-config-degrading-session",
          "title": "Degrading session",
          "duration": "0:00"
        },
        {
          "number": "20.7",
          "id": "cl-env-config-session-hygiene",
          "slug": "env-config-session-hygiene",
          "title": "Session hygiene",
          "duration": "0:00"
        },
        {
          "number": "20.8",
          "id": "cl-env-config-reflection",
          "slug": "env-config-reflection",
          "title": "Operational discipline reflection",
          "duration": "0:00"
        }
      ],
      "isPublished": false
    },
    {
      "number": "21",
      "title": "Aside · The Cheap Path and the Real One",
      "lessons": [
        {
          "number": "21.1",
          "id": "cl-aside-what-not-cheap-means",
          "slug": "aside-what-not-cheap-means",
          "title": "What \"don't do it cheap\" actually means",
          "duration": "0:00"
        },
        {
          "number": "21.2",
          "id": "cl-aside-shortcuts-erase-decision-trail",
          "slug": "aside-shortcuts-erase-decision-trail",
          "title": "Shortcuts erase the decision trail",
          "duration": "0:00"
        },
        {
          "number": "21.3",
          "id": "cl-aside-bootability-is-the-foundation-gate",
          "slug": "aside-bootability-is-the-foundation-gate",
          "title": "Bootability is the foundation gate",
          "duration": "0:00"
        },
        {
          "number": "21.4",
          "id": "cl-aside-repeatability-needs-automation-and-boundaries",
          "slug": "aside-repeatability-needs-automation-and-boundaries",
          "title": "Repeatability needs automation and boundaries",
          "duration": "0:00"
        },
        {
          "number": "21.5",
          "id": "cl-aside-ship-evidence-with-release",
          "slug": "aside-ship-evidence-with-release",
          "title": "Ship the evidence with the release",
          "duration": "0:00"
        },
        {
          "number": "21.6",
          "id": "cl-aside-where-this-doesnt-apply",
          "slug": "aside-where-this-doesnt-apply",
          "title": "And where this doesn't apply",
          "duration": "0:00"
        },
        {
          "number": "21.7",
          "id": "cl-aside-agent-failures-dont-go-away",
          "slug": "aside-agent-failures-dont-go-away",
          "title": "Agent failures don't go away",
          "duration": "0:00"
        },
        {
          "number": "21.8",
          "id": "cl-aside-trades-control-for-leverage",
          "slug": "aside-trades-control-for-leverage",
          "title": "This doesn't make the work thoughtless — it trades control for leverage",
          "duration": "0:00"
        }
      ],
      "isPublished": false
    },
    {
      "number": "22",
      "title": "Close",
      "lessons": [
        {
          "number": "22.1",
          "id": "cl-close-complete-picture",
          "slug": "close-complete-picture",
          "title": "The complete picture",
          "duration": "0:00"
        },
        {
          "number": "22.2",
          "id": "cl-close-not-the-model-the-control-loop",
          "slug": "close-not-the-model-the-control-loop",
          "title": "The difference isn't the model. It's the control loop.",
          "duration": "0:00"
        },
        {
          "number": "22.3",
          "id": "cl-close-seven-things-around-the-model",
          "slug": "close-seven-things-around-the-model",
          "title": "Seven things around the model that make the difference",
          "duration": "0:00"
        },
        {
          "number": "22.4",
          "id": "cl-close-two-things-optimised",
          "slug": "close-two-things-optimised",
          "title": "Two different things being optimised",
          "duration": "0:00"
        },
        {
          "number": "22.5",
          "id": "cl-close-in-public-not-self-promotion",
          "slug": "close-in-public-not-self-promotion",
          "title": "\"In public\" doesn't mean self-promotion",
          "duration": "0:00"
        },
        {
          "number": "22.6",
          "id": "cl-close-publish-wrong-decisions",
          "slug": "close-publish-wrong-decisions",
          "title": "Publish the wrong decisions too",
          "duration": "0:00"
        },
        {
          "number": "22.7",
          "id": "cl-close-not-one-afternoon",
          "slug": "close-not-one-afternoon",
          "title": "This paper trail can't be built in one afternoon",
          "duration": "0:00"
        },
        {
          "number": "22.8",
          "id": "cl-close-words-that-kept-coming-back",
          "slug": "close-words-that-kept-coming-back",
          "title": "The words that kept coming back",
          "duration": "0:00"
        },
        {
          "number": "22.9",
          "id": "cl-close-five-references",
          "slug": "close-five-references",
          "title": "Five references worth keeping close",
          "duration": "0:00"
        },
        {
          "number": "22.10",
          "id": "cl-close-where-do-you-hit-friction",
          "slug": "close-where-do-you-hit-friction",
          "title": "Where do you hit the most friction building software with an AI agent?",
          "duration": "0:00"
        },
        {
          "number": "22.11",
          "id": "cl-close-where-to-go-from-here",
          "slug": "close-where-to-go-from-here",
          "title": "Where to go from here",
          "duration": "0:00"
        },
        {
          "number": "22.12",
          "id": "cl-close-course-close",
          "slug": "close-course-close",
          "title": "Course close",
          "duration": "0:00"
        }
      ],
      "isPublished": false
    }
  ]
}
